module.exports = __webpack_public_path__ + "img/setChecked3.b9263850.png";